import { defineRouting } from 'next-intl/routing';
import { LOCALES } from '@core/constants/locales.constants';
import templateConfig from '@templateConfig';

export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: templateConfig.localization.defaultRouterLocale,
  localePrefix: 'always',
  pathnames: templateConfig.navigation.pathnames,
  alternateLinks: false, // We can't use this one because slugs for dynamic pages are localized. So we manage this in metadata.
});
